import translator from 'i18next';
import { Languages } from 'core/localization/entities';

const useGetLanguage = () => {
  return translator.language as Languages;
};

export default useGetLanguage;
